import { render, staticRenderFns } from "./editRemark.vue?vue&type=template&id=7e0823e2&scoped=true"
import script from "./editRemark.vue?vue&type=script&lang=js"
export * from "./editRemark.vue?vue&type=script&lang=js"
import style0 from "./editRemark.vue?vue&type=style&index=0&id=7e0823e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0823e2",
  null
  
)

export default component.exports